import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};
`
